
import { useLocation } from "react-router-dom";
import { SubscriptionStatus } from "@/services/subscription";

interface UseStripeSubscriptionCheckProps {
  lastCheckedStatus: SubscriptionStatus | null;
  isSubscriptionActive: (status: SubscriptionStatus | null) => boolean;
  isCheckingSubscriptionRef: React.MutableRefObject<boolean>;
  setLastCheckedStatus: (status: SubscriptionStatus | null) => void;
  hasCheckedSubscriptionRef: React.MutableRefObject<boolean>;
  forceRefresh?: () => void;
  onLoadSubscriptionStatus: (userId: string) => Promise<SubscriptionStatus | null>;
}

export const useStripeSubscriptionCheck = ({
  lastCheckedStatus,
  isSubscriptionActive,
  isCheckingSubscriptionRef,
  setLastCheckedStatus,
  hasCheckedSubscriptionRef,
  forceRefresh,
  onLoadSubscriptionStatus
}: UseStripeSubscriptionCheckProps) => {
  const location = useLocation();

  const checkStripeSubscription = async (userId: string): Promise<boolean> => {
    const justActivated = localStorage.getItem('subscription_activated');
    const stripeSuccess = new URLSearchParams(location.search).get('success') === 'true';
    
    if ((justActivated || stripeSuccess) && forceRefresh && !isCheckingSubscriptionRef.current) {
      console.log('Activation detected, forcing refresh');
      isCheckingSubscriptionRef.current = true;
      forceRefresh();
      
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const freshStatus = await onLoadSubscriptionStatus(userId);
      isCheckingSubscriptionRef.current = false;
      
      if (freshStatus && isSubscriptionActive(freshStatus)) {
        setLastCheckedStatus(freshStatus);
        localStorage.setItem('subscription_confirmed_active', 'true');
        window.dispatchEvent(new Event('subscription_updated'));
        hasCheckedSubscriptionRef.current = true;
        return true;
      }
    }
    
    return false;
  };

  return { checkStripeSubscription };
};
